// The pathname the page fader is actually SHOWING, as opposed to the router's
// live location. PageTransition (App.jsx) keeps the old page on screen through
// its fade-out after a route change, so anything that has to match the page
// on screen, rather than the destination, reads this instead.
//
// The header's brands mode is the case it exists for. Keyed on the live
// route, the header went fixed (out of the flow) the instant BRANDS was
// pressed, while the old page was still fading out beneath it, and that page
// jumped up by the header's height; leaving /brand, the header dropped back
// into the flow and pushed the brand page down the same way. Keyed here, it
// changes at the swap, under the fade.
let current = typeof window !== "undefined" ? window.location.pathname : "/";
const listeners = new Set();

export function setDisplayedPath(path) {
  if (path === current) return;
  current = path;
  for (const listener of listeners) listener();
}

export function getDisplayedPath() {
  return current;
}

export function subscribeDisplayedPath(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
